<template>
    <div ref="box" class="box">
        <b-img v-for="item in images" :key="item" height="420px" :src="item" />
        <b-container fluid>
            <b-row class="bottom text-light">
                <b-col lg="2">
                    <div>
                    </div>
                </b-col>
                <b-col>
                    <b-container>
                        <b-row align-h="between" align-v="end">
                            <b-col cols="4">
                                <b-row>
                                    <b-col>
                                        <p class="display-3 font-weight-bold mb-0">
                                            {{place.name}}
                                        </p>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col class="d-flex mb-2">
                                        <Star
                                            :rating="place.averageRating"
                                            :fontScale=2
                                            :readOnly=true 
                                        />
                                        <div class="h5 mx-3">
                                            {{place.numberOfRatings}} reviews
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col class="d-flex ml-2">
                                        <div class="h5">
                                            Unclaimed
                                        </div>
                                        <div class="h5 mx-3">
                                            ⸱
                                        </div>
                                        <div class="h5">
                                            ₱₱
                                        </div>
                                        <div class="h5 mx-3">
                                            ⸱
                                        </div>
                                        <div class="h5">
                                            {{categories}}
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="1.5">
                                <b-button @click="goToPhotos" variant="outline-light">
                                    <span class="h5 m-3">See {{place.numberOfPhotos}} photos</span>
                                    </b-button>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-col>
                <b-col lg="2">
                    <div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style scoped>
.box {
    overflow:hidden;
    white-space:nowrap;
    height: 420px;
    object-fit: cover;
    filter: brightness(100%);
}

.bottom {
    position: absolute;
    right: 0;
    left: 0;
    bottom: 0px;
    padding-top: 90px;
    padding-left: 10px;
    padding-right: 10px;
    height: 280px;
    background: linear-gradient(to top, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
}
</style>

<script>
import Star from './Star'

export default {
    components: {
        Star
    },
    data() {
        return {
            
        }
    },
    computed: {
        place: {
            get() {
                return this.$store.state.place_current_data
            }
        },
        categories: {
            get() {
                var tmp = ''
                this.place.categories.forEach(category => {
                    if (tmp == '') {
                        tmp = category.name
                    } else {
                        tmp = tmp + ', ' + category.name
                    }
                })
                return tmp
            }
        },
        images: {
            get() {
                var list = []
                list.push(this.place.imageUrl)
                list.push(this.place.imageUrl)
                list.push(this.place.imageUrl)
                list.push(this.place.imageUrl)
                //list.push('https://s3-media0.fl.yelpcdn.com/bphoto/T-hh7JmMqC8V2gbwOdK6KQ/l.jpg')
                //list.push('https://s3-media0.fl.yelpcdn.com/bphoto/wbleN1qffqYuXnV9hV0EZg/l.jpg')
                //list.push('https://s3-media0.fl.yelpcdn.com/bphoto/VG94_pHBiPt8EPDv0sy0dQ/o.jpg')
                //list.push('https://s3-media0.fl.yelpcdn.com/bphoto/7CJX83WiPiZ6PPsxRsDIsA/l.jpg')
                return list
            }
        }
    },
    methods: {
        goToPhotos() {
            console.log('going to photos')
            this.$router.push({
                name: 'Photos',
                params: {}
            })
        }
    },
    mounted() {
       
    }
}
</script>